function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.222%",
  y1: "50%",
  x2: "100%",
  y2: "69.331%",
  id: "d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02A1A1",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1BC0C0",
  offset: "83.681%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1BC0C0",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "31.571%",
  y1: "60.259%",
  x2: "78.375%",
  y2: "42.416%",
  id: "g"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0,
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "58.156%",
  y1: "94.764%",
  x2: "100%",
  y2: "5.236%",
  id: "h"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02A1A1",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1BC0C0",
  offset: "73.159%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1BC0C0",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100%",
  y1: "50%",
  x2: "0%",
  y2: "50%",
  id: "l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DDD",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "n"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#03A3A3",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02A1A1",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h112v154H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.112 75.611h-.369l-.238-.002h-.602a21.638 21.638 0 0 0-1.081.035l-.152.01.152-.01-.195.014.043-.003a9.444 9.444 0 0 0-.225.02l.182-.017a9.22 9.22 0 0 0-.198.019l.016-.002a8.002 8.002 0 0 0-.196.023l.18-.021a7.77 7.77 0 0 0-.237.029l.057-.008a6.353 6.353 0 0 0-.485.081l.089-.018-.143.03.054-.012a4.77 4.77 0 0 0-.182.043l.128-.03c-.42.093-.794.235-1.106.447l-.046.032.046-.032a2.238 2.238 0 0 0-.137.1l.09-.068c-.045.033-.09.067-.132.103l.042-.034a2.136 2.136 0 0 0-.128.11l.086-.076c-.046.039-.09.079-.132.12l.046-.044a2.087 2.087 0 0 0-.11.112l.064-.067a2.08 2.08 0 0 0-.122.131l.057-.064a2.087 2.087 0 0 0-.121.145l.064-.08c-.034.04-.067.082-.098.126l.034-.046a2.14 2.14 0 0 0-.093.132l.059-.086a2.178 2.178 0 0 0-.106.16l.047-.074a2.362 2.362 0 0 0-.208.4c-1.072 2.637 1.165 3.747 3.986 3.567l.024-.001a10.224 10.224 0 0 0 .745-.078c.471-.066.95-.166 1.427-.298l.068-.019a33.69 33.69 0 0 1 1.571-.38l.188-.04c5.422-1.144 20.205-2.98 23.941 10.01.045.156.09.316.131.478a3.563 3.563 0 0 1 .113.837v.096l-.005.117-.001.025a3.229 3.229 0 0 1-.224.993l-.004.011a3.255 3.255 0 0 1-.348.643l-.024.035a2.928 2.928 0 0 1-.159.206l-.038.044a3.285 3.285 0 0 1-.543.506 3.348 3.348 0 0 1-.49.308l-.018.009-.082.04-.031.016-.07.031-.09.039-.037.014a2.85 2.85 0 0 1-.356.12 3.089 3.089 0 0 1-.144.036l-.08.017a2.129 2.129 0 0 1-.164.03 2.946 2.946 0 0 1-.125.019c-.009 0-.017.002-.026.003a2.767 2.767 0 0 1-.26.02 5.147 5.147 0 0 1-.187.003l-.078-.001-.099-.005-.064-.004a3.014 3.014 0 0 1-.12-.011l-.036-.004a3.268 3.268 0 0 1-.48-.09l.093.021-.094-.02-.354-.09a35.565 35.565 0 0 0-2.825-.598c-1.559-.255-2.992-.334-4.557-.199a19.874 19.874 0 0 0-1.763.232c-1.836.32-3.937.907-6.63 1.809l.361-.121-.36.121-1.398.466-1.38.456c-44.993 14.817-72.277 17.4-90.774 9.584C14.494 98.279 0 78.325 0 54.965l.007-.91C.49 24.12 24.774 0 54.661 0h7.483c30.19 0 54.662 24.608 54.662 54.965l-.01 1.048a56.612 56.612 0 0 1-.235 4.144c.002 0 .001.005 0 .012-.032.33-.066.66-.103.99.022 1.096.482 2.84 2.923 3.904a61.79 61.79 0 0 1 2.423.855l.161.06.162.062.153.06a37.626 37.626 0 0 1 .606.243l.056.024c.932.386 1.802.8 2.68 1.304l.128.075.067.039c.457.265.878.533 1.262.802l.007.006.2.14c.082.058.16.117.238.176l.015.012a8.573 8.573 0 0 1 .14.11c2.657 2.107 2.277 4.485.035 5.662l-.06.03-.092.046-.045.022a5.51 5.51 0 0 1-.415.175 7.883 7.883 0 0 1-.342.12l-.034.011a8.207 8.207 0 0 1-.796.214 10.102 10.102 0 0 1-.727.133l-.02.003a12.459 12.459 0 0 1-.789.091 16.283 16.283 0 0 1-1.003.058 23.623 23.623 0 0 1-.84.014l-.323.001h-.116z",
  id: "c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.55 0c-8.758.012-13.784 11.01-14.502 12.282-1.56 2.761-4.584 5.214-6.893 2.465-1.058-1.26-.117-3.59.704-4.923 1.387-2.25-.46-5.068-3.068-4.718C12.03 6.821-2.58 20.28.39 37.44c1.556 8.995 12.358 20.273 30.269 11.817 11.948-6.23 13.519-18.121 15.917-32.049 1.08-6.266 3.948-9.17 6.776-10.467 2.438-1.118 2.509-4.59.05-5.664C51.692.327 50.086.003 48.589 0h-.038z",
  id: "i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8.05C10.614 7.177 16.807 2.873 20.513 0c3.712 2.876 10.907 7.177 21.51 8.05-.073 9.335-2.126 26.704-21.513 36.781C1.128 34.777.072 17.403 0 8.05z",
  id: "k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 .001v32.662C28.417 24.59 31.526 16.29 32.212 6.287 25.308 5.037 19.925 2.51 16.002 0L16 .001",
  id: "o"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-6.4%",
  y: "-8.6%",
  width: "112.8%",
  height: "117.2%",
  filterUnits: "objectBoundingBox",
  id: "e"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -8,
  dy: 4,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0509803922 0 0 0 0 0.435294118 0 0 0 0 0.521568627 0 0 0 0.201081389 0",
  in: "shadowInnerInner1"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-17.2%",
  y: "-18.2%",
  width: "134.4%",
  height: "136.4%",
  filterUnits: "objectBoundingBox",
  id: "j"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -3,
  dy: 9,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.105882353 0 0 0 0 0.752941176 0 0 0 0 0.752941176 0 0 0 1 0",
  in: "shadowInnerInner1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.898 3)"
}, /*#__PURE__*/React.createElement("ellipse", {
  fill: "#EFEFEF",
  cx: 91.602,
  cy: 145,
  rx: 56.5,
  ry: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.443 146a3.367 3.367 0 0 1-3.357-3.375v-13.15a3.366 3.366 0 0 1 3.357-3.375 3.366 3.366 0 0 1 3.357 3.376v13.149A3.367 3.367 0 0 1 58.443 146",
  fill: "#1D1D1B"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.102 26.12)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#d)",
  xlinkHref: "#c"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#e)",
  xlinkHref: "#c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m63.556 42.256-2.644 1.137A1 1 0 0 1 59.6 42.08l1.137-2.644-1.137-2.643a1 1 0 0 1 1.313-1.314l2.644 1.137 2.644-1.137a1 1 0 0 1 1.314 1.314l-1.137 2.643 1.137 2.644a1 1 0 0 1-1.314 1.314l-2.644-1.137z",
  fill: "#FFF",
  mask: "url(#f)",
  transform: "rotate(45 63.556 39.435)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.422-3.56c-9.657.006-15.198 6.086-15.99 6.789-1.721 1.527-5.055 2.882-7.6 1.363-1.168-.697-.13-1.985.775-2.722 1.53-1.244-.506-2.801-3.383-2.608C38.151.21 22.042 7.65 25.316 17.136c1.716 4.972 13.627 11.207 33.377 6.532 13.176-3.443 14.293-10.99 19.033-16.9 1.19-3.465 6.902-1.046 10.02-1.763 2.689-.619-1.263-7.377-3.973-7.97a24.872 24.872 0 0 0-5.308-.595h-.043z",
  fill: "url(#g)",
  opacity: 0.198,
  mask: "url(#f)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.245)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#h)",
  xlinkHref: "#i"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#j)",
  xlinkHref: "#i"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M49.784 67.632c0 1.5-1.209 2.714-2.7 2.714-1.49 0-2.7-1.215-2.7-2.714 0-1.5 1.21-2.714 2.7-2.714 1.491 0 2.7 1.215 2.7 2.714M68.937 67.632c0 1.5-1.209 2.714-2.7 2.714-1.49 0-2.7-1.215-2.7-2.714 0-1.5 1.21-2.714 2.7-2.714 1.491 0 2.7 1.215 2.7 2.714",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.1 72.73c-4.427 0-8.016 3.61-8.016 8.06h16.032c0-4.45-3.59-8.06-8.016-8.06",
  fill: "#FFDA00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.658 86.278c3.014 0 5.458-2.456 5.458-5.487H52.2c0 3.03 2.444 5.487 5.457 5.487",
  fill: "#F2A100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.908 146a3.367 3.367 0 0 1-3.357-3.375v-13.15a3.366 3.366 0 0 1 3.357-3.375 3.366 3.366 0 0 1 3.356 3.376v13.149A3.366 3.366 0 0 1 94.908 146",
  fill: "#1D1D1B"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M25.158 136.904C-3.837 123.667.172 91.954.206 91.544c.046-.567.52-1.01 1.078-1.01 16.127 0 23.434-10.098 23.516-10.19.194-.219.486-.344.802-.344.316 0 .609.125.802.343.083.093 8.402 9.19 24.517 9.19.558 0 1.031.444 1.078 1.01.033.41 3.042 33.124-25.954 46.361a1.076 1.076 0 0 1-.887 0z",
  fill: "#0D6F85"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.09 86.404)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "m",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#k"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#k"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#l)",
  opacity: 0.597,
  mask: "url(#m)",
  d: "m4.512 12.596-4.5-4.5-2.5 11 10 21.5 13.5 7 13-8.5 9.5-17.5 1-14.5-2.5 1-5 4.5-18 6.5z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.702 92.809)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .001v32.662C12.417 24.59 15.526 16.29 16.212 6.287 9.308 5.037 3.925 2.51.002 0L0 .001",
  fill: "url(#n)",
  transform: "matrix(-1 0 0 1 16.212 0)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#0D6F85",
  xlinkHref: "#o"
}))))));

function SvgImgHomeProtectionFinix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 154,
    viewBox: "0 0 112 154",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHomeProtectionFinix);
export default __webpack_public_path__ + "static/media/img_home_protection_finix.c55c40da.svg";
export { ForwardRef as ReactComponent };